const hoverTime = 400; // Tiempo antes de hacer prefetch (en ms)
const fetchers = {};
const doc = document.implementation.createHTMLDocument("prefetch");

function fetchPage(url, success) {
    fetch(url, {
        headers: {
            "VND.PREFETCH": "true",
            "Accept": "text/html"
        }
    })
        .then(response => {
            if (!response.ok) throw new Error("Error al cargar la página");
            return response.text();
        })
        .then(html => success(html))
        .catch(error => console.error("Prefetch error:", error));
}

function prefetchTurbolink(url) {
    if (!window.Turbolinks) return; // Asegurar que Turbolinks está presente

    fetchPage(url, responseText => {
        doc.open();
        doc.write(responseText);
        doc.close();

        // Crear snapshot y almacenarlo en la caché de Turbolinks
        const snapshot = Turbolinks.Snapshot.fromHTMLElement(doc.documentElement);
        Turbolinks.controller.cache.put(url, snapshot);
    });
}

function prefetch(url) {
    if (prefetched(url)) return;
    prefetchTurbolink(url);
}

function prefetched(url) {
    return location.href === url || (window.Turbolinks && Turbolinks.controller.cache.has(url));
}

function prefetching(url) {
    return !!fetchers[url];
}

function cleanup(event) {
    const element = event.target;
    clearTimeout(fetchers[element.href]);
    element.removeEventListener("mouseleave", cleanup);
}

function setupPrefetch() {
    document.addEventListener("mouseover", event => {
        const link = event.target.closest("a");
        if (!link || !link.dataset.prefetch) return;

        const url = link.href;
        if (prefetched(url) || prefetching(url)) return;

        cleanup(event);
        link.addEventListener("mouseleave", cleanup);
        fetchers[url] = setTimeout(() => prefetch(url), hoverTime);
    });
}

// Exportamos para poder importarlo en otro archivo
export default {
    setupPrefetch
};
